<template>
    <div class="approveManage">
        <!--tab切换-->
        <div class="key_list" style="background: #ffffff;padding-top: 22px;padding-bottom: 0;">
            <el-button type="primary" :class="{tavactive:tavactive==3}" style="background: #eeeeee;border-color: #eeeeee;width: 134px;height: 38px;color: #333333" @click="getSearch(3)">我发起的</el-button>
            <el-button type="primary" :class="{tavactive:tavactive==1}" style="background:#eeeeee ;border-color: #eeeeee;width: 134px;height: 38px;color: #333333" @click="getSearch(1)">待我审批</el-button>
            <el-button type="primary" :class="{tavactive:tavactive==2}" style="background: #eeeeee;border-color: #eeeeee;width: 134px;height: 38px;color: #333333" @click="getSearch(2)">我已审批</el-button>
            <el-button type="primary" :class="{tavactive:tavactive==''}" style="background: #eeeeee;border-color: #eeeeee;width: 134px;height: 38px;color: #333333" @click="getSearch('')">所有审批</el-button>
        </div>
        <!-- 搜索 -->
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item">
                    <span>申请人：</span>
                    <el-input v-model="search.name" @change="pageNumber=1,currentPage=1,queryCostApplication()" placeholder="请输入" clearable>
                    </el-input>
                </li>
                <li class="conditions_list_item">
                    <span>申请日期：</span>
                    <span class="total_inp">
            <el-date-picker v-model="search.applyDate" type="daterange" align="right" @change="pageNumber=1,currentPage=1,queryCostApplication()" placeholder="请选择" nlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </span>
                </li>
                <li class="conditions_list_item">
                    <span>状态：</span>
                    <el-select v-model="search.applyStatus" @change="pageNumber=1,currentPage=1,queryCostApplication()" placeholder="不限"
                               clearable>
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>类型：</span>
                    <el-select v-model="search.holidayTypeName" @change="pageNumber=1,currentPage=1,queryCostApplication()" placeholder="不限"
                               clearable>
                        <el-option v-for="(item,index) in holidayList" :key="index" :label="item.type" :value="item.type">
                        </el-option>
                    </el-select>
                </li>
            </ul>
            <div class="key_list" style="min-width: 390px" v-if="tavactive==3">
                <el-button type="primary" style="background: #22CA85;border-color: #22CA85" @click="dialogVisible1=true">请假申请</el-button>
                <el-button type="primary" style="background:#5E75E6 ;border-color: #5E75E6" @click="dialogVisible=true">外勤申请</el-button>
                <el-button type="primary" style="background: #FF904D;border-color: #FF904D" @click="dialogVisible2=true">补卡申请</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="list" border style="width: 100%" @row-click="rowColorclick" highlight-current-row
                      :header-cell-style="setHeaderStyle" @row-dblclick="rowDetailShow">
                <el-table-column prop="holidayName" label="类型" width="150"></el-table-column>
                <el-table-column prop="title" label="标题" width="220"></el-table-column>
                <el-table-column label="关联业务" width="180">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.id===isRowColor}" style="color: #5E75E6" @click="toOther(scope.row.detailId,scope.row.businessType,scope.row.businessStatus)">{{scope.row.detailName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="applyEmployeeName" label="申请人" width="150"></el-table-column>
                <el-table-column prop="applyDate" label="申请时间" width="200"></el-table-column>
<!--                <el-table-column prop="beginDatetime" label="请假或补卡时间"></el-table-column>-->
<!--                <el-table-column prop="holidayNumber" label="时长（小时）"></el-table-column>-->
                <el-table-column prop="applyDemo" label="详情"></el-table-column>
                <el-table-column label="状态" width="150">
                    <template slot-scope="scope">
            <span :class="{rowColor:scope.row.id===isRowColor}"
                  :style="scope.row.checkStatus=='审批同意'?'color:#2CA203':scope.row.checkStatus=='审批中'?'color:rgb(255, 112, 0)':scope.row.checkStatus=='已撤回'?'color:#999999':scope.row.checkStatus=='无效'?'color:#999999':'color:#FF4726'"
                  @click="detailShow(scope.row)">{{scope.row.checkStatus}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 30, 40]"
                               layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>

        <!-- 请假申请弹窗 -->
        <!-- 外勤 -->
        <LeaveRequest v-if="dialogVisible" :sta="dialogVisible" @cancel="dialogVisible=false,queryCostApplication()" />

        <!-- 请假 -->
        <FieldRequest v-if="dialogVisible1" :sta="dialogVisible1" @cancel="dialogVisible1=false,queryCostApplication()" />

        <!-- 补卡 -->
        <RepairCardRequest v-if="dialogVisible2" :sta="dialogVisible2"
                           @cancel="dialogVisible2=false,queryCostApplication()" />

        <!-- 请假详情 -->

        <ExaminDetail v-if="dialogVisible3" :examinId="examinDate.id" :sta="dialogVisible3"
                      @cancel="dialogVisible3=false,queryCostApplication()" />

        <!-- 请假详情补卡 -->
        <examinCardDetail v-if="dialogVisible4" :examinId="examinDate.id" :sta="dialogVisible4"
                          @cancel="dialogVisible4=false,queryCostApplication()" />
    </div>
</template>

<script>
    import { storeFind,queryWhetherHavePermission} from "@/api/manageCenter";
    import {
        addApplication,
        queryCostApplication,
        queryCostDetail,
        updateStatus,
        holidayQuery
    } from "@/api/checkingIn";
    import LeaveRequest from "../checkingIn/examinComponent/leaveRequest";
    import FieldRequest from "../checkingIn/examinComponent/fieldRequest";
    import RepairCardRequest from "../checkingIn/examinComponent/repairCardRequest";
    import ExaminDetail from "../checkingIn/examinComponent/examinDetail";
    import examinCardDetail from "../checkingIn/examinComponent/examinCardDetail";
    import { format } from "path";
    import { getRouterLevel } from "@/vue/util/tool";

    export default {
        // name: "审批管理",
        name: "/approveManage",
        components: {
            LeaveRequest,
            FieldRequest,
            RepairCardRequest,
            ExaminDetail,
            examinCardDetail
        },

        data() {
            let permisList = JSON.parse(sessionStorage.getItem("permisList"));
            return {
                permisList,
                tavactive:3,
                isRowColor: "",
                search: {
                    applyDate: [], //申请日期
                    holidyDate: [], //请假或补卡时间
                    name: "", //申请人编号
                    applyStatus: "", //申请状态
                    holidayTypeName: "", //请假类型编号
                    type: 3 //
                }, //搜索列表
                list: [], //审批管理列表
                examinDate: {},
                statusList: [
                    {
                        label: "审批中",
                        value: "TO_BE_AUDITED"
                    },
                    {
                        label: "审批同意",
                        value: "AUDITED"
                    },
                    {
                        label: "审批拒绝",
                        value: "UNABLE"
                    }, {
                        label: "无效",
                        value: "INVALID"
                    },
                    {
                        label: "已撤回",
                        value: "WITHDRAW"
                    }
                ], //请假状态列表
                holidayList: [], //查询请假类型列表
                examineHolidayList: [
                    {
                        label: "待我审批",
                        value: "1"
                    },
                    {
                        label: "我已审批",
                        value: "2"
                    },
                    // {
                    //   label: "我发起的",
                    //   value: "3"
                    // },
                ], //审批类型列表
                total: 0, //每页条数
                currentPage: 1, //页数
                pageNumber: 1,
                pageSize: 20,
                dialogVisible: false, //导出弹框显示隐藏
                dialogVisible1: false,
                dialogVisible2: false,
                dialogVisible3: false,
                dialogVisible4: false
            };
        },
        mounted() {
            // this.getStoreList();
            this.queryCostApplication();
            this.holidayQuery();
            this.isRowColor = "";
            // this.queryWhetherHavePermission();
            // if (sessionStorage.getItem('customerApplyId')){
            //     this.dialogVisible3 = true;
            //     this.examinDate.id = sessionStorage.getItem('customerApplyId');
            //     sessionStorage.removeItem('customerApplyId')
            // }
        },
        activated() {
            this.queryCostApplication();
            this.holidayQuery();
            this.isRowColor = "";
            this.queryWhetherHavePermission();
        },
        methods: {
            //审批详情权限
            queryWhetherHavePermission(){
                if (sessionStorage.getItem('customerApplyId')){
                    let params = {
                        id:sessionStorage.getItem('customerApplyId')
                    };
                    this.$post(queryWhetherHavePermission,params).then(res=>{
                        if (res.data){
                            this.dialogVisible3 = true;
                            this.examinDate.id = sessionStorage.getItem('customerApplyId');
                            sessionStorage.removeItem('customerApplyId')
                        }else {
                            sessionStorage.removeItem('customerApplyId')
                            this.$message.error('暂无权限');
                        }
                    })
                }
            },
            toOther(id,type,businessStatus){
                if (businessStatus=='DELETE'){
                    this.$message.error('该关联业务已删除');
                } else {
                    if (type) {
                        if (type==='SHOP_SALE') {
                            //商铺买卖
                            sessionStorage.setItem("buildId", id);
                            sessionStorage.setItem("sellShopbuildId", id);
                            this.$store.state.houseType = "SHOP_SALE";
                            this.$router.push('/sellShopDetails')
                        }else if (type==='SHOP_RENTAL') {
                            //商铺租赁
                            sessionStorage.setItem("buildId", id);
                            sessionStorage.setItem('rentShopbuildId',id);
                            this.$store.state.houseType = "SHOP_RENTAL";
                            this.$router.push('/rentShopDetails')
                        }else if (type==='SECONDHAND') {
                            //二手房
                            sessionStorage.setItem("buildId", id);
                            sessionStorage.setItem("sellHousebuildId",id);
                            this.$store.state.houseType = "SECONDHAND";
                            this.$router.push('/buildDetail')
                        }else if (type==='RENTING') {
                            //租房
                            sessionStorage.setItem("buildId", id);
                            sessionStorage.setItem('rentHousebuildId',id);
                            this.$store.state.houseType = "RENTING";
                            this.$router.push('/rentingBuildDetail')
                        }else if (type==='WANT_TO_BUY') {
                            //客源求购
                            localStorage.setItem("customerId", id);
                            localStorage.setItem('ketype',type);
                            this.$router.push('/purchaseDetail')
                        }else if (type==='WANT_TO_RENT') {
                            //客源求租
                            localStorage.setItem("customerId", id);
                            localStorage.setItem('ketype',type);
                            this.$router.push('/purchaseDetail')
                        }else if (type==='black') {
                            //黑名单
                            this.$router.push('/blackList')
                        }
                    }
                    console.log(id,type);
                }

            },
            getSearch(val){
                this.pageNumber=1;
                this.currentPage=1;
                this.search.type=val;
                this.tavactive=val;
                this.queryCostApplication()
            },
            permisShow(data) {
                // 权限配置
                let result = this.permisList.indexOf(data);
                if (result >= 0) {
                    return true;
                } else {
                    return false;
                }
            },

            rowColorclick(row) {
                this.isRowColor = row.id;
            },

            queryCostApplication() {
                let params = Object.assign(this.search, {});
                delete params.holidayTypeId;
                delete params.checkId;
                this.isRowColor = "";
                // 查询请假申请列表
                if (this.search.holidayTypeName) {
                    let holidayTypeName = this.search.holidayTypeName;
                    this.holidayList.map(item => {
                        if (item.type == holidayTypeName) {
                            if (item.id) {
                                params.holidayTypeId = item.id;
                            } else {
                                params.checkId = item.checkId;
                            }
                        }
                    });
                }

                params["page.pageNumber"] =
                    this.pageNumber * this.pageSize - this.pageSize;
                params["page.pageSize"] = this.pageSize;
                let result = this.permisShow("审批管理查看");
                if (result >= 0) {
                    params.permissionLevel = getRouterLevel("审批管理查看");
                }
                if(params.holidayTypeId){
                    params.checkId = ''
                }
                this.$post(queryCostApplication, params).then(res => {
                    if (res.success) {
                        this.list = res.data;
                        this.total = res.total;
                    } else {
                        this.$message.error(res.msg);
                        this.list = [];
                    }
                });
            },

            holidayQuery() {
                // 查询请假类型列表
                let params = {
                    whetherOpen: "ALL"
                };
                this.$post(holidayQuery, params).then(res => {
                    if (res.success) {
                        this.holidayList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },

            detailShow(data) {
                this.examinDate = data;
                console.log(111, data);
                // if (data.holidayName.indexOf("补卡") >= 0) {
                //     this.dialogVisible4 = true;
                // } else {
                //     // this.holidaystatus = data.holidayName;
                //     this.dialogVisible3 = true;
                // }
                this.dialogVisible3 = true;
            },

            rowDetailShow(row, column, event) {
                console.log(111, row);
                this.examinDate = row;
                // if (row.holidayName.indexOf("补卡") >= 0) {
                //     this.dialogVisible4 = true;
                // } else {
                //     // this.holidaystatus = row.holidayName;
                //     this.dialogVisible3 = true;
                // }
                this.dialogVisible3 = true;
            },

            //分页
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.queryCostApplication();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNumber = 1;
                this.queryCostApplication();
            },
            //表单头部颜色
            setHeaderStyle() {
                return "background-color: #F2F4FF";
            },
            goto() {
                this.$router.push("attendanceStatistics");
            }
        }
    };
</script>
<style lang="less">
    .approveManage {
        .key_list {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            padding: 10px 0;
            .conditions_list_item {
                padding: 5px 0 0 10px;
                display: flex;
                align-items: center;
                margin-right: 20px;
                position: relative;
                overflow: hidden;
                cursor: pointer;
                > span {
                    line-height: 20px;
                    font-size: 12px;
                    color: #666666;
                    padding: 0;
                    /*padding-right: 10px;*/
                }
                .el-input {
                    width: 110px;
                    height: 30px;

                    .el-input-group__append,
                    .el-input-group__prepend {
                        padding: 0 10px;
                        background: #cccccc;
                        border: none;
                    }

                    .el-input__inner {
                        height: 30px;
                        border: 1px solid #dbdbdb;
                    }

                    .icon-icon_sousuo {
                        color: white;
                    }
                }
                .el-select {
                    margin-left: 10px;
                    .el-input {
                        width: 100px;
                        .el-input__inner {
                            width: 100px;
                            height: 30px;
                            border: 1px solid #dbdbdb;
                            color: black;
                            padding: 0;
                            padding-left: 10px;
                        }
                        .el-input__icon {
                            line-height: 30px;
                        }
                    }
                }
                .total_inp {
                    border: none;
                    display: flex;
                    align-items: center;
                    height: 30px;
                    width: 240px;
                    padding-right: 0;
                    .el-date-editor {
                        width: 240px;
                        height: 30px;
                        border: 1px solid #dbdbdb;
                        align-items: center;
                        .el-range-input {
                            width: 90px;
                            .el-input__inner {
                                width: 90px;
                            }
                        }
                        .el-input__icon {
                            line-height: 25px !important;
                        }
                        .el-range-separator{
                            line-height: 25px;
                        }
                    }

                    .el-range-input {
                    }
                }
            }
        }
        .el-button--primary {
            margin-left: 30px;
            // margin-top: 20px;
            width: 100px;
            height: 30px;
            padding: 0;
            background: #5e75e6;
            border-color: #5e75e6;
        }
    }
</style>
<style lang='less' scoped>
    .approveManage {
        /*margin-left: 14px;*/
        height: 100%;
        .tavactive{
            /*box-shadow: 4px 4px 6px #999999;*/
            background: #5E75E6!important;
            border-color:#5E75E6!important;
            color: #ffffff!important;
        }
        .el-table .cell,
        .el-table th div,
        .el-table--border td:first-child .cell,
        .el-table--border th:first-child .cell {
            text-align: center;
        }

        .key_top {
            display: flex;
            justify-content: space-between;
            align-items: top;
            padding: 10px 20px;
            background: #fff;

            .add_btn {
                width: 100px;
                height: 30px;
                background: #5e75e6;
                color: white;
                outline: none;
                border: none;
            }
        }

        .key_list_wrap {
            .el-dialog {
                width: 600px;

                .el-dialog__title {
                    color: #5e75e6;
                    font-size: 20px;
                }

                .el-dialog__close {
                    font-size: 26px;
                }

                .el-dialog__body {
                    padding-left: 0;
                    padding-right: 0;
                    padding-bottom: 0;
                }
            }

            .footer_page {
                margin-top: 20px;
                display: flex;
                justify-content: flex-end;
                margin-bottom: 20px;

                .el-pagination.is-background .el-pager li:not(.disabled).active {
                    background-color: #5e75e6;
                }

                .el-pagination.is-background .btn-next,
                .el-pagination.is-background .btn-prev,
                .el-pagination.is-background .el-pager li {
                    border: 1px solid #ccc;
                    background: white;
                }
            }
        }
    }
</style>